module.exports = __webpack_public_path__ + "static/media/bg-9.7da12bac.png";